import { createStore } from 'vuex';

import auth from './auth/index.js';
import user from './user/index.js'
import block from './block/index.js';
import follow from './follow/index.js';
import main from './main/index.js';
import modals from './modal/index.js';
import posts from './posts/index.js'
import notifications from './notifications/index.js';
import metrics from './metrics/index.js';
import org from './org/index.js';

const store = createStore({
  modules: {
    auth,
    main,
    modals,
    notifications,
    block,
    follow,
    posts,
    user,
    metrics,
    org
  },
});

export default store;
